module.exports = __webpack_public_path__ + "static/advert-393fc59609edc9cbce1334b1dc24851a.jpg";